/**  @jsx jsx */
import { css, jsx } from '@emotion/core';
var ellipsisStyles = css({
  display: 'inline-flex',
  padding: '0 8px',
  alignItems: 'center',
  textAlign: 'center'
});
export default function renderEllipsis(_ref) {
  var key = _ref.key;
  return jsx("span", {
    key: key,
    css: ellipsisStyles
  }, "...");
}